<c11n-modal-dialog [variant]="'basic'"
                   [headingText]="'Message detail'"
                   [hasForm]="true" #message_detail_search_modal
                   [modalId]="'message-detail-modal'"
                   (closeEvent)="cancelButtonHandler()"

>
  <div c11n-modal-dialog-body>
    <c11n-banner class="c11n-space-stack-2x c11n-space--force"
                 [size]="'small'"
                 [variant]="'error'"
                 [hasCloseControl]="false"
                 *ngIf="showErrors">Please fill out at least one of the search criteria.
    </c11n-banner>
    <form
      autocomplete="off"
      [formGroup]="formGroup"
      (ngSubmit)="submitForm($event)"
    >
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-5 col-xs-12 c11n-space-stack-3x c11n-space--force">
          <label
            c11n-label
            for="message_number"
          >Message number</label>
          <c11n-input>
            <input
              c11nInput
              id="message_number"
              type="text"
              placeholder=""
              aria-describedby="message_number"
              [attr.readonly]="isWaiting ? true : null"
              required
              name="message_number"
              formControlName="message_number"
            />
          </c11n-input>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
          <c11n-select
            labelText="Message type"
            [hintText]="''"
            [hasError]="false"
          >
            <select
              c11nSelectInput

              id="message_type"
              aria-describedby="message_type"
              [attr.disabled]="isWaiting ? true : null"
              required
              formControlName="message_type"
            >
              <option *ngIf="formGroup.controls['message_type'].invalid" value="" data-option="placeholder" selected
                      disabled>Select one
              </option>
              <!-- [value] used as [attr.value] not working as expected -->
              <option *ngFor="let type of messageTypes" [value]="type">{{ type }}</option>
            </select>
          </c11n-select>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
          <!--<c11n-radio-group
            groupId="messages"
            legendText=""

          >-->
          <c11n-radio
            labelText="Show all permanent messages"
          >
            <input
              c11nRadioInput
              id="permanent_messages"
              type="radio"
              value="permanent"
              aria-describedby="permanent_messages"
              [attr.disabled]="isWaiting ? true : null"
              required
              formControlName="show_messages"
            />
          </c11n-radio>
          <c11n-radio
            labelText="Show all unverifiesd messages"
          >
            <input
              c11nRadioInput
              id="verified_messages"
              type="radio"
              value="verified"
              aria-describedby="verified_messages"
              [attr.disabled]="isWaiting ? true : null"
              required
              formControlName="show_messages"
            />
          </c11n-radio>
          <!--</c11n-radio-group>-->
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12 c11n-space-stack-3x c11n-space--force">
          <!-- Use flex-column-reverse on mobile, flex-sm-row on larger screens -->
          <div class="d-flex flex-column-reverse flex-sm-row gap-2 button_between_gap">
            <c11n-button
              labelText="Submit"
              buttonType="submit"
              [isInvalid]="formGroup.invalid"
              [isWaiting]="isWaiting"
              [fullWidth]="(responsive.isMobile$ | async) ?? false"
            ></c11n-button>
            <c11n-button
              labelText="Cancel"
              variant="secondary"
              [fullWidth]="(responsive.isMobile$ | async) ?? false"
              (clickEvent)="cancelButtonHandler()"
            ></c11n-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</c11n-modal-dialog>
